module.exports = __webpack_public_path__ + "static/media/3taylorcarusoactually.00ca5b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3taylorcarusoactually.png
// module id = 103
// module chunks = 0